Controller = App.loadClass 'core::Angular/Controller'

class exports.OnFarmStorageController extends Controller
    constructor: (@scope, @transitions, @state, @modal, @service, @loading, @q) ->
        super

        App.sidebar?.close()
        App.angularSidebar?.close()
        @scope.title = 'OFS Inspections and Estimates'
        @scope.fullpage = true
        @scope.alwaysReenable = true
        @filters = {}
        @users = []
        @contracts = []
        @bins = []
        @measurement = new @service.Measurement

        @service.getYears().then (years) =>
            @years = years
            @filters.year = years[0]
            @onYearChange()

        @scope.save = () =>
            @clearAlert()
            promises = []
            for bin in @bins
                do (bin) =>
                    promise = @service.saveBinId @filters.year, bin
                    .then (data) =>
                        bin.unUnique = false
                        return data
                    .catch (err) =>
                        bin.unUnique = true
                        return @q.reject err
                    promises.push promise
            if @measurement.measured_pounds? or @measurement.measurement_date?
                if @measurement.id?
                    promises.push @measurement.$update()
                else
                    promises.push @measurement.$save()
            @q.all promises
            .then (all) =>
                @setAlert
                    type: 'success'
                    msg: 'Saved successfully'
            .catch (err) =>
                msgs = []
                if err.data.measured_pounds?
                    msgs = msgs.concat err.data.measured_pounds
                if err.data.measurement_date?
                    msgs = msgs.concat err.data.measurement_date
                if err.data.binId?
                    msgs = msgs.concat err.data.binId
                if msgs.length
                    @setAlert
                        type: 'error'
                        msg: 'Validation Errors'
                    , msgs
                else
                    throw err

    editBin: (bin) ->
        original = angular.copy bin
        @modal.open
            windowClass: 'larger_dialog'
            templateUrl: 'backend/portal/on-farm-storage/bin-details-layout'
            controller: 'BinDetailsController'
            controllerAs: 'bdc'
            resolve:
                bin: -> bin
                noSave: -> false
        .result
        .then () =>
            @loadBins()
        .catch () ->
            angular.copy original, bin

    editInspection: (bin) ->
        original = angular.copy bin.inspection
        @modal.open
            windowClass: 'larger_dialog'
            templateUrl: 'backend/portal/on-farm-storage/inspection-layout'
            controller: 'OnFarmStorage.Controllers.BinInspectionsController'
            controllerAs: 'bic'
            resolve:
                bin: -> bin
                year: => @filters.year
        .result
        .then () ->
            bin.noInspection = false
        .catch () ->
            angular.copy original, bin.inspection

    onYearChange: () ->
        @filters.user = null
        @filters.contract = null
        @users = []
        @contracts = []
        @bins = []
        @service.getUsers @filters.year
        .then (users) =>
            @users = users

    onUserChange: () ->
        # Reset contract filters and list
        @filters.contract = null
        @filters.bin = null
        @contracts = []
        @bins = []

        @loadContracts()
        @loadBins()

    loadContracts: () ->
        # Get contracts
        contractsLoading = @loading.overCustom '#ofs-contracts', 'Loading...'
        @service.getContracts @filters.year, @filters.user
        .then (contracts) =>
            @contracts = contracts
            contractsLoading.hide()

    loadBins: () ->
        # Get bins
        binsLoading = @loading.overCustom '#ofs-bins', 'Loading...'
        @service.getBins @filters.user
        .then (bins) =>
            for bin in bins
                do (bin) =>
                    @service.getBinId @filters.year, bin.id
                    .then (binId) ->
                        bin.bin_id = binId
                    @service.BinInspection.query binId: bin.id, year: @filters.year
                    .$promise.then (inspections) ->
                        if inspections.length
                            bin.inspection = inspections[0]
                        else
                            # Turn off spinner
                            bin.noInspection = true
            @bins = bins
            binsLoading.hide()

    ###
    # Step 1
    # Select contract. If already selected, deselect
    # If a bin is selected, deselect
    ###
    onContractClick: (contract, bin) ->
        @filters.contract = if @filters.contract is contract then null else contract
        @filters.bin = if @filters.bin is bin then null
        @measurement = new @service.Measurement

    ###
    # Step 2
    # Select bin. If already selected, deselect
    ###
    onBinClick: (bin, $event) ->
        return if $event.target.nodeName is 'INPUT' or $event.target.nodeName is 'BUTTON'
        @filters.bin = if @filters.bin is bin then null else bin
        @_loadMeasurement(@filters.contract, @filters.bin)

    _loadMeasurement: (contract, bin) ->
        return unless contract? and bin?
        measurementLoading = @loading.overCustom '#ofs-measurement-details', 'Loading...'
        @service.getMeasurementId contract, bin
        .then (measurementId) =>
            @service.Measurement.get id: measurementId
            .$promise.then (@measurement) =>
                @measurement.storage_locations_id = bin.id
                @measurement.contracts_id = contract.id
                measurementLoading.hide()
        .catch () =>
            @measurement = new @service.Measurement
                storage_locations_id: bin.id
                contracts_id: contract.id
            measurementLoading.hide()
